import { mdlStatus } from "./CompAttachmentsMdl";

 

export class mdlCalculateTravelRefundRes {
    st: mdlStatus;
    TravelRefund: mdlTravelRefund;
}

export class mdlTravelRefund {
    GrossAmount: number ;
    VATPercent: number ;
    VATAmount: number ;
    PremiumPaid: number ;
    RefundAmount: number ;
    RefundVATAmount: number ;
    TotalRefundAmount: number ;
    ApplicableMatrix: number ;
    AdminFee: number ;
    RefundAfterAdminFee: number ;
    RefundDays: number ;
    PolicyUsedDays: number ;
    RefundType: string;
    RefundBrokerComm: number ;
    InsuranceType: string;
    IsSendToUW: number ;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlCalculateTravelRefundRes.ts